module.exports = __webpack_public_path__ + "img/30.19c90753.png";